import React from 'react';

export const SectionHeader = ({ className, textColor, content }: { className?: string; textColor: string; content: string }) => {
  return <h2 className={`text-display-sm font-bold sm:text-display-md tracking-minus2 ${textColor} ${className}`}>{content}</h2>;
};
